import React from 'react';
import { FaTimes, FaExclamationTriangle } from 'react-icons/fa';

const DeleteModal = ({ isOpen, onClose, onConfirm, itemName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 !m-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md p-4">
      <div className="bg-white rounded-xl shadow-business max-w-md w-full">
        <div className="bg-gradient-to-r from-red-600 to-red-700 p-6 rounded-t-xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="bg-white bg-opacity-20 p-2 rounded-lg">
                <FaExclamationTriangle className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-display font-bold text-white">Confirm Delete</h3>
                <p className="text-red-100">This action cannot be undone</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-lg transition-colors"
            >
              <FaTimes className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="p-6">
          <p className="text-secondary-700 mb-6">
            Are you sure you want to delete <strong>"{itemName}"</strong>? This action cannot be undone.
          </p>

          <div className="flex space-x-4">
            <button
              onClick={onConfirm}
              className="flex-1 bg-gradient-to-r from-red-600 to-red-700 text-white py-3 px-6 rounded-lg font-semibold hover:from-red-700 hover:to-red-800 transition-all shadow-md hover:shadow-lg"
            >
              Delete
            </button>
            <button
              onClick={onClose}
              className="flex-1 bg-secondary-100 text-secondary-700 py-3 px-6 rounded-lg font-semibold hover:bg-secondary-200 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;